// //DEV
// export function getBrowserEnv() {
//   return {
//     NODE_ENV: "development",
//     NEWSLETTER_API: "https://beta.ikarus3d.com/api/v1/newsletter",
//     SITE_KEY: "6LcSfv4lAAAAAONjiSdV0DcgEc1M9sPgE8Y8j9Dr", //# This is the SITE KEY provided by reCaptcha
//     CDN_BASE_URL: "https://d3cv7syas17klq.cloudfront.net",
//     WEBSITE_BASE_URL: "https://beta.ikarus3d.com",
//     MEDIA_URL: "https://beta.ikarus3d.com/media/",
//     BLOG_URL: "https://beta.ikarus3d.com/media/3d-blog/",
//     HIRE_US: "https://beta.ikarus3d.com/api/v1/hire-us",
//   };
// }

//PROD
export function getBrowserEnv() {
  return {
    NODE_ENV: "production",
    NEWSLETTER_API: "https://ikarus3d.com/api/v1/newsletter",
    SITE_KEY: "6LfMjwQmAAAAAOKYqDzJX4SUbnESVbzDkABBpcXC",
    CDN_BASE_URL: "https://d3cv7syas17klq.cloudfront.net",
    WEBSITE_BASE_URL: "https://ikarus3d.com",
    MEDIA_URL: "https://ikarus3d.com/media/",
    BLOG_URL: "https://ikarus3d.com/media/3d-blog/",
    HIRE_US: "https://ikarus3d.com/api/v1/hire-us",
  };
}
